import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getLearningPathLessonExams } from "../../../api/endpoints/LearningPathEndpoints";
import { Exercise } from "../../../models/Exercise";
import { Paged } from "../../../models/Paged";

export default function useGetLearningPathExamsPaginated(
  learningPathId: string,
  lessonId: string,
) {
  return useMutation<Paged<Exercise>, AxiosError, { page: number }>({
    mutationKey: ["exams"],
    mutationFn: ({ page }) =>
      getLearningPathLessonExams(learningPathId, lessonId, page),
  });
}
